import { useState } from "react";
import { toast } from "sonner";
import { Flame } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const MOTIVOS = [["uso_interno", "Uso interno"], ["merma", "Merma / daño"], ["otro", "Otro"]];

export default function RegistrarConsumo({ insumo, sucursalId, onClose, onGuardado }) {
  const [cantidad, setCantidad] = useState("");
  const [motivo, setMotivo] = useState("uso_interno");
  const [nota, setNota] = useState("");
  const [guardando, setGuardando] = useState(false);
  if (!insumo) return null;
  async function guardar(e) {
    e.preventDefault();
    setGuardando(true);
    try {
      const { data } = await api.post("/consumos", { componente_id: insumo.componente_id || insumo.id, cantidad: parseFloat(cantidad), motivo, nota, sucursal_id: sucursalId });
      toast.success(`${data.folio}: consumo registrado · quedan ${data.stock_resultante} ${insumo.unidad || ""}`);
      if (data.alerta_bajo) toast.warning(`${insumo.nombre} quedó ${data.stock_resultante <= 0 ? "en cero" : `bajo su mínimo (${data.stock_minimo})`}. Programa su reposición.`, { duration: 8000 });
      onGuardado?.(data); onClose();
    } catch (err) { toast.error(formatApiError(err)); } finally { setGuardando(false); }
  }
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-sm rounded-2xl" data-testid="consumo-dialog">
        <DialogHeader><div className="eyebrow">Consumible</div><DialogTitle className="font-display text-lg font-bold">Registrar consumo</DialogTitle></DialogHeader>
        <form onSubmit={guardar} className="space-y-3">
          <div className="rounded-xl border border-brand-line bg-brand-surface px-3 py-2"><div className="font-semibold text-sm text-brand-ink">{insumo.nombre}</div><div className="text-xs text-brand-muted font-mono">{insumo.sku} · existencia {insumo.stock} {insumo.unidad || ""}{insumo.stock_minimo ? ` · mín ${insumo.stock_minimo}` : ""}</div></div>
          <div><label className="eyebrow">Cantidad consumida ({insumo.unidad || "pzas"})</label><input data-testid="consumo-cantidad" type="number" step="any" min="0.001" max={insumo.stock} required autoFocus value={cantidad} onChange={(e) => setCantidad(e.target.value)} className="field mt-1 font-mono" /></div>
          <div><label className="eyebrow">Motivo</label><select data-testid="consumo-motivo" value={motivo} onChange={(e) => setMotivo(e.target.value)} className="field mt-1">{MOTIVOS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></div>
          <div><label className="eyebrow">Nota (opcional)</label><input data-testid="consumo-nota" value={nota} onChange={(e) => setNota(e.target.value)} placeholder="Ej. rollo para etiquetas de pedido TR-000120" className="field mt-1" /></div>
          <p className="text-[11px] text-brand-muted">Baja el stock de esta sucursal y registra el valor a costo como gasto "Consumibles" del área correspondiente (P&L).</p>
          <button data-testid="consumo-guardar" disabled={guardando} className="btn-ink w-full h-11"><Flame className="w-4 h-4 text-brand-amber" /> {guardando ? "Guardando…" : "Descontar del stock"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
